import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@base/environments/environment';
import { HttpService } from '../../core/http.service';

@Injectable({
  providedIn: 'root',
})
export class ChangeUserOldFEService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/change/user/v2';
    this.baseUrl = environment.oldFrontUrl;
  }
}
